<template>
    <div class="page-header-style">
        <div class="row" style="padding:10px; margin:0px">
            <ul class="nav nav-pills">
                <li class="disabled"><h4 style="margin-left:15px; margin:10px" class="text-primary"><b><em>Pharmacy Users</em></b></h4></li>


                <li class="pull-right">
                    <router-link :to="{ name: 'manage-pharmacy-user' }">
                        Add User
                    </router-link>
                </li>
            </ul>
            <!--<hr style="margin-top:0px" />-->
        </div>
        <br />
        <transition name="fade" :duration="1000">
            <div v-show="isLoading" class="row" style="width:100%; position:absolute;text-align:center; vertical-align:central">
                <br /><br /><br />
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i>
                <span class="sr-only">Loading...</span>
            </div>
        </transition>
        <datatable :columns="columns" :source="getRecords" @selected="recordSelected" v-if="!isLoading"></datatable>
    </div>
</template>


<script>
    import datatable from "../../corecontrols/datatable/datatable.scp.html";
    import { CarehomeDto } from './../../../dto/carehomedto'
    import { UserDto, UserPermissionDto } from "./../../../dto/Dtos";
    import Dal from './../../../scripts/dataaccess'
    import Formatter from "../../corecontrols/formatters/Formatter"

    export default {
        props: [],
        mounted: function () {
            var dal = new Dal();
            dal.GetCarehomes().then(data => {
                this.carehomes = data
                console.log("this.carehomes ", data)
            })
        },
        data: function () {
            var formatDate = Formatter.FormatDate;
            var that = this;
            return {
                carehomes: [],
                columns: [
                    {
                        name: "Name", render: function (data, type, row) {

                            return (row.firstName || "") + " " + (row.lastName || "")
                        }
                    }
                    , { name: "Email", data: "email" }
                    , { name: "Phone", data: "number" }
                    , {
                        name: "Permissions", render: function (data, type, row) {
                            var permissions = row.userPermissions;
                            var result = "";
                            var first = true;
                            for (var permission of permissions) {
                                //if (permission.permissionId == 3 || permission.permissionId == 5) {
                                //    if (first) {
                                //        first = false;
                                //    }
                                //    else {
                                //        result += "<br/>"
                                //    }
                                //    result +=  (permission.permissionId == 5 ? "Carer" : "Manager") + " : " + that.getCarehomeName(permission.carehomeId);
                                //}
                                //else
                                if (permission.permissionId == 2 || permission.permissionId == 4) {
                                    if (first) {
                                        first = false;
                                    }
                                    else {
                                        result += "<br/>"
                                    }
                                    result += (permission.permissionId == 2 ? "Admin" : "User") + " : " + permission.unit.name;
                                }
                            }
                            return result;
                        }
                    }
                ]
            }
        },
        methods: {
            //formatDate: function (dt) {
            //    return Formatter.FormatDate(dt);
            //},
            getCarehomeName: function (carehomeId) {
                console.log("Carehomes ", this.carehomes, carehomeId)
                for (var ch of this.carehomes) {
                    if (ch.id == carehomeId) {
                        console.log("Carehome ----s ", ch)
                        return ch.name;
                    }
                }
                return "";
            },
            getRecords: function (callback) {
                var dal = new Dal();
                dal.GetUnitUsers().then(data => {
                    //dal.GetUsers().then(data => {
                    console.log(data);
                    var records = { data: data };
                    callback(records);
                });
            },

            recordSelected: function (record) {
                var id = record.id;
                this.$router.push({ name: 'manage-pharmacy-user', params: { userid: id } })

            }
        },
        components: {
            datatable,
            Formatter
        }
    }
</script>


// WEBPACK FOOTER //
// user-list.scp.html?f564cc1e